import {
  FETCHING, SUCCESS, ERROR, RESET,
} from './actions'

export const initialState = {
  response: undefined,
  isFetching: false,
  isError: false,
  isSuccess: false,
  error: undefined,
}

export const requestReducer = (state = initialState, { type, response }: { type: string, response?: any }) => {
  switch (type) {
    case FETCHING:
      return {
        ...initialState, isSuccess: false, isFetching: true, isError: false,
      }
    case SUCCESS:
      return {
        ...state, isSuccess: true, response, isFetching: false, isError: false,
      }
    case ERROR:
      /* eslint-disable max-len */
      return {
        ...state, isSuccess: false, response: undefined, isFetching: false, isError: true, error: response,
      }
    case RESET:
      return { ...initialState }
    default:
      return state
  }
}
